$(function() {
  var checkValid = function(elm) {
    if (elm.val()) {
      elm.addClass('fill');
    }

    return elm.on('keyup change', function() {
      if (elm.val()) {
        return elm.addClass('fill');
      } else {
        return elm.removeClass('fill');
      }
    });
  };

  window.initAdaptivePlaceholders = function() {
    var inputs = $(document).find('.form-group.adaptive-placeholder :input').not('.boolean');
    return inputs.each(function() {
      return checkValid( $(this) );
    });
  };

  initAdaptivePlaceholders();
});

